module.exports = __webpack_public_path__ + "static/img/solution-case-en.6f39b52.png";


//////////////////
// WEBPACK FOOTER
// ./src/assets/images/solution-case-en.png
// module id = Zmfd
// module chunks = 1